import React, { useState, useEffect } from 'react';

import './styles.css';

import productServices from '../../../../../services/admFin/productServices';

import Popup from '../../../../../components/Popup';
import PopupProductNewMovement from './PopupProductNewMovement';
import ListInfos from '../../../../../components/ListInfos';
import MovementsItem from './MovementsItem';
import ActivityIndicator from '../../../../../components/ActivityIndicator';
import { FaCube, FaPrint } from 'react-icons/fa';
import PopupReports from '../../../../../components/PopupReports';
import reportServices from '../../../../../services/reportServices';

export default function PopupProduct(props) {
    const [popupProductNewMovementVisible, setPopupProductNewMovementVisible] = useState(false);
    const [product, setProduct] = useState({});
    const [movements, setMovements] = useState([]);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (props.data)
            setProduct(props.data);
    }, [props.data]);

    useEffect(() => {
        if (props.data.id)
            readStockMovements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data.id]);

    async function readStockMovements() {
        setFetching(true);
        const response = await productServices.getStockMovements(props.data.id);
        setFetching(false);
        if (response.status === 200) {
            setMovements(response.data);
        } else
            alert("Erro ao ler movimentações do produto, tente novamente!");
    }

    async function readProduct() {
        const response = await productServices.getProduct(props.data.id);
        if (response.status === 200) {
            setProduct(response.data);
            if (props.onUpdate) props.onUpdate(response.data);
        } else
            alert("Erro ao ler produto, tente novamente!");
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportStockHistoric(movements, `RELATÓRIO DE HISTÓRICO DE MOVIMENTAÇÕES DO PRODUTO ${product.nome}`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaCube />}
            tittle="Produto"
            id="product"
        >
            <div className="infos">
                <div className="line close">
                    <h4><b>{product.nome}</b></h4>
                    <span className="tag center">COD {product.id}</span>
                </div>
                <h3>{product.quantidade} {product.quantidade === 1 ? "unidade" : "unidades"}</h3>
                {product.quantidade_critica ? <p><b>Estoque crítico:</b> {product.quantidade_critica}</p> : null}
                {product.centro_de_custo ? <p><b>Centro de custo:</b> {product.centro_de_custo.nome}</p> : null}
                {product.plano_de_contas ? <p><b>Plano de contas:</b> {product.plano_de_contas.nome}</p> : null}

                {
                    product.quantidade < product.quantidade_critica ?
                        <div className="tags">
                            <span className="tag strong red">
                                {product.quantidade_critica - product.quantidade} {product.quantidade_critica - product.quantidade === 1 ? "UNIDADE" : "UNIDADES"} ABAIXO DO ESTOQUE CRÍTICO
                            </span>
                        </div>
                        : null
                }
            </div>

            <div className="line">
                <button className="light-blue" onClick={() => props.editProduct(product)}>Editar</button>

                <button onClick={() => setPopupProductNewMovementVisible(true)}>Movimentar</button>
                <PopupProductNewMovement
                    visibility={popupProductNewMovementVisible}
                    setVisibility={setPopupProductNewMovementVisible}
                    product={product}
                    onCreate={() => {
                        readProduct();
                        readStockMovements();
                    }}
                />
            </div>

            {
                !fetching ?
                    <>
                        <ListInfos
                            tittle="Histórico"
                            counter={movements.length}
                            counterName="movimentações"
                            singleCounterName="movimentação"
                        />
                        <button onClick={() => setVisibilityReport(true)}><FaPrint /></button>

                        <ul className='list'>
                            {
                                movements.map((item, index) =>
                                    <MovementsItem
                                        key={item.id}
                                        type={item.tipo}
                                        tittle={`${item.tipo === 1 ? "Saída" : "Entrada"} de ${item.quantidade} ${item.quantidade === 1 ? "unidade" : "unidades"}`}
                                        description={(item.conta ? "Conta: " : "") + item.descricao}
                                        date={item.data}
                                        author={item.autor}
                                    />
                                )
                            }
                        </ul>
                    </>
                    : <ActivityIndicator />
            }
            <PopupReports
                visibility={visibilityReport}
                setVisibility={setVisibilityReport}
                tittle={`Histórico de movimentações`}
                fields={reportServices.stockHistoricFields}
                generateReport={generateReport}
            />
        </Popup>
    )
}